class CustomGoogleMap{
   
  mapDivElem: HTMLElement | null;
  constructor() {
    this.init();
  }

  init() {
    this.mapDivElem = document.getElementById("google-custom-map");
    if(this.mapDivElem){
      this.initMap();
    }
  }

  async initMap(): Promise<void> {
    if (!this.mapDivElem) return;
    try{
      let map: google.maps.Map;
      const { Map } = await google.maps.importLibrary("maps") as google.maps.MapsLibrary;
      const { AdvancedMarkerElement } = await google.maps.importLibrary("marker") as google.maps.MarkerLibrary;
      map = new Map(this.mapDivElem as HTMLElement, {
        center: {lat: 51.059091, lng: -114.076152}, 
        zoom: 14,
        fullscreenControl: false,
        mapId: '2d9cb20409b92032'
      });
      const marker = new AdvancedMarkerElement({
        map,
        position: {lat: 51.064140, lng: -114.088500}, //SAIT Campus
      });
    }
    catch(error){
      
    }

    
  }

}

export default CustomGoogleMap;